import { useEffect, useState } from "react";
import { ICodesView } from "../codes";
import { Map } from "../../../../common/components/map/map";
import { IQrCode } from "../../models";
import { IMapPin } from "../../../../common/components/map/models";

export const MapView = (data: ICodesView) => {
  const [selected, setSelected] = useState<IQrCode>();
  const [locations, setLocations] = useState<IMapPin[]>([]);

  useEffect(() => {
    data.codes?.map((code) => {
      const location: IMapPin = {
        id: code.id,
        latitude: code.latitude,
        longitude: code.longitude,
        altitude: code.altitude,
      };
      setLocations((locations) => [...locations, location]);
    });
  }, []);

  const assignSelected = (id: string) => {
    const match = data.codes.find((x) => x.id === id);
    setSelected(match);
  };

  const create = (pin: IMapPin) => {
    const item: IQrCode = {
      id: pin.id,
      created: new Date(),
      description: "",
      latitude: pin.latitude,
      longitude: pin.longitude,
      altitude: pin.altitude,
      heading: 0,
    };
    data.edit?.(item);
  };

  useEffect(() => {
    if (selected) {
      data.generate?.(selected);
    }
    setSelected(undefined);
  }, [selected]);

  return (
    <Map locations={locations} selected={assignSelected} onClick={create} />
  );
};
